import { red } from "@mui/material/colors";
import PropTypes from "prop-types";
import React from "react";
import { useLocation } from "react-router-dom";
import Hub from "../components/Hub";
import HubList from "../components/HubList";

const measureCharts = [
  {
    type: "bloodpressure",
    label: "Blood Pressure",
    value: [
      {
        key: "systolic",
        color: "#8884d8",
        bounds: [{ color: red[500], value: 180 }, 141],
      },
      {
        key: "diastolic",
        color: "#82ca9d",
        bounds: [85],
      },
    ],
  },
  {
    type: "weight",
    label: "Weight",
    value: [{ key: "weight_lbs", color: "#BE4297" }],
  },
  {
    type: "pulseox",
    label: "Pulseox",
    value: [
      {
        key: "spo2",
        color: "#8884d8",
        bounds: [81],
      },
    ],
  },
];

export default function PressureCheck({ programId }) {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const hubId = queryParams.get("hub");

  return !hubId ? (
    <HubList programId={programId} measureCharts={measureCharts} />
  ) : (
    <Hub
      hubId={hubId}
      measureCharts={measureCharts}
      programId={programId}
      aggregateValues
      isCHF
    />
  );
}
PressureCheck.propTypes = {
  programId: PropTypes.string.isRequired,
};
